export default __webpack_public_path__ + "static/media/fb-copy.f40a9228.jpg";